<template lang="pug">
    //- Barra de filtros de búsqueda
    .b2b-filters
        b2b-search-bar
            div.header(slot='header')
                <span class='dateHeader'> {{ $t('invoices.filters.creation_date.value') }}</span>
                ods-date-picker(
                    v-model='dateTimePickerValue',
                    type='datetimerange',
                    :picker-options='pickerOptions2',
                    @change='getDateTimePickerValue',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    :format='$t("date_format_long_datepicker")',
                    :canSelectSeconds='true',
                    :clearable='false',
                    clearIcon='',
                    :default-time="['00:00:00', '23:59:59']",
                    prefix-icon='prefix-icon-date-time-picker',
                    :showFooterButtons='true',
                    align='right')
                ods-tooltip.ods-ml-4(:content='$t("invoices.buttons.refresh_tooltip")', placement='bottom')
                  ods-button(
                      icon='ods-icon-refresh',
                      size='medium',
                      @click="activeRefreshInvoices")
                ods-tooltip(:content='$t("invoices.buttons.upload_invoice_tooltip")', placement='bottom')
                  ods-button(
                      v-if='canUploadInvoice',
                      size='medium',
                      icon="ods-icon-upload",
                      @click.native='activateUpload')
                      | {{ $t('invoices.buttons.upload_invoice') }}
            div(slot='body')
                ods-form.b2b-filters__area(
                    :model='filterForm',
                    :rules='rules',
                    ref='filterForm',
                    @submit.native.prevent='')

                    ods-form-item.first-input(prop='firstValue')
                        ods-select(
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.firstValue',
                            :placeholder='$t("msg_generics.advanced_search")',
                            @change='getFirstValue')
                            ods-option(
                                v-for='option in options',
                                :key='option.col',
                                :label='$t(option.value)',
                                :disabled='option.selected',
                                :value='option')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        //- Select type
                        div(v-if="(selected.componente === 'select' && selected.prop !== 'sellerId' && selected.prop !== 'statusId')")
                            ods-form-item.others-input(prop='secondValueSelect')
                                ods-select(v-if="selected.prop === 'idProject'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.id',
                                        :label='option.name',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'documentClassCode'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='(option, index) in selected.options',
                                        :key='option.id',
                                        :label='$t("document_class." + option)',
                                        :value='option')
                                ods-select(v-else-if="selected.prop === 'paymentMethod'"
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                    v-for='(option, index) in selected.options',
                                    :key='option.id',
                                    :label='$t("paymentmethod." + option.name)',
                                    :value='option.id')
                                ods-select(v-else-if="selected.prop === 'currencyId'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.id',
                                        :label='$t("currency." + option.code)',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'buyerId'",
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :filter-method='filterPartiesBuyer',
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                      v-for='option in selected.options',
                                      :key='option.id',
                                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                      :value='option.id')
                                ods-select(v-else-if="selected.prop === 'withAttachment' || selected.prop === 'cancellationRequest'",
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                      v-for='option in selected.options',
                                      :key='option.id',
                                      :label='$t("msg_generics.question." + option.type)',
                                      :value='option.id')
                                ods-select(v-else-if="selected.prop === 'channelId'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.id',
                                        :label='option.name',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'sent'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in optionsInvoiceSent',
                                        :key='option.code',
                                        :label='option.value',
                                        :value='option.code')
                                ods-select(v-else-if="selected.prop === 'noErrorStatus'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in noErrorStatusOptions',
                                        :key='option.value',
                                        :label='option.code',
                                        :value='option.value')
                                ods-select(v-else
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                      v-for='option in selected.options',
                                      :key='option.id',
                                      :label='formatterLabel(option.code)',
                                      :value='option.id')

                        //-Exclusivo sellerID
                        div(v-else-if="(selected.componente === 'select' && selected.prop === 'sellerId')")
                          ods-form-item.others-input(prop='secondValueSelect')
                            div(v-if="(userLoggedOneProjectOneParty || userLoggedOneProjectOnePartyOneCentre)")
                              ods-tooltip( placement="top")
                                template(slot='content')
                                  | {{this.optionsFilterInvoiceEmitSeller[0].tradeName}}
                                ods-select(
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  :placeholder='$t(selected.placeholder)',
                                  :disabled='true')
                                  ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                            div(v-else)
                              ods-select(
                                :no-match-text='$t("msg_generics.no_match")',
                                v-model='filterForm.secondValueSelect',
                                filterable,
                                :filter-method='filterPartiesSeller',
                                :placeholder='$t(selected.placeholder)',
                                @change='getSecondValue')
                                ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                        div(v-else-if="(selected.componente === 'select' && selected.prop === 'statusId')")
                          ods-form-item.others-input(prop='secondValueSelectMultiple')
                            ods-select(v-if="selected.prop === 'statusId'",
                              :no-match-text='$t("msg_generics.no_match")',
                              v-model='filterForm.secondValueSelectMultiple',
                              filterable,
                              multiple,
                              collapse-tags,
                              :placeholder='$t(selected.placeholder)',
                              @change='getSecondValue')
                              ods-option(
                                v-for='option in selected.options',
                                :key='option.id',
                                :label='$t("invoice_status." + option.code)',
                                :value='option.id')
                            div(v-else)
                              ods-select(
                                :no-match-text='$t("msg_generics.no_match")',
                                v-model='filterForm.secondValueSelect',
                                filterable,
                                :filter-method='filterPartiesSeller',
                                :placeholder='$t(selected.placeholder)',
                                @change='getSecondValue')
                                ods-option(
                                  v-for='option in selected.options',
                                  :key='option.id',
                                  :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                  :value='option.id')
                        //- INVOICE NUMBER
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceNumber')")
                         ods-form-item.others-input(prop='invoiceNumber')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model.trim='filterForm.invoiceNumber',
                                    @input='getSecondValue')
                        //- REGISTER NUMBER
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'registerNumber')")
                         ods-form-item.others-input(prop='registerNumber')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.registerNumber',
                                    @input='getSecondValue')
                        //- SERIES CODE
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceSeriesCode')")
                         ods-form-item.others-input(prop='invoiceSeriesCode')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.invoiceSeriesCode',
                                    @input='getSecondValue')
                        //- ID INTERNO
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'id')")
                         ods-form-item.others-input(prop='id')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.id',
                                    @input='getSecondValue')
                        //- TASAS
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'rate')")
                         ods-form-item.others-input(prop='rate')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.rate',
                                    @input='getSecondValue')
                        //- Input type
                        div(v-else-if="selected.componente === 'input' && selected.tipo === 'string' && (selected.prop !== 'rate' || selected.prop !== 'id' || selected.prop !== 'invoiceSeriesCode' || selected.prop !== 'invoiceNumber' || selected.prop === 'registerNumber')")
                            ods-form-item.others-input(prop='secondValue')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.secondValue',
                                    @input='getSecondValue')
                        //- Date Type
                        div(v-else-if="selected.componente === 'date'")
                            ods-date-picker(
                                v-model='filterDatePickerValue',
                                type='daterange',
                                :picker-options='pickerOptions2',
                                @change='getDateRangePickerValue',
                                :range-separator='$t("msg_generics.datepicker.separator")',
                                :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                                :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                                :format='$t("date_format_calendar")',
                                prefix-icon='prefix-icon-date-time-picker',
                                align='right')
                        //- Importes
                        div(v-else-if="selected.tipo === 'number' && (selected.prop === 'totalExecutableAmountTo' || selected.prop === 'totalExecutableAmountFrom')")
                            ods-form-item.others-input(prop='secondValueDecimal')
                                ods-input.others-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.secondValueDecimal',
                                    @input='getSecondValue')
                        div(v-else)
                            ods-form-item.others-input(prop='secondValueNumber')
                                ods-input.others-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.secondValueNumber',
                                    @input='getSecondValue')

                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show="(selected.prop === 'buyerId' || selected.prop === 'sellerId') && filterForm.secondValueSelect")
                       ods-form-item.others-input(prop='thirdValueSelect')
                        ods-select(
                          v-if="(selected.prop === 'buyerId' && selectedBuyer)"
                          :no-match-text='$t("msg_generics.no_match")',
                          v-model='filterForm.thirdValueSelect',
                          filterable,
                          multiple,
                          collapse-tags,
                          :placeholder='$t(selectedCentre.placeholder)')
                          ods-option(
                            v-for='option in selectedCentre.options',
                            :key='option.id',
                            :label='option.code',
                            :value='option.id')
                        ods-select(
                           v-if="(!this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'sellerId' && (selectedSeller || this.userLoggedOneProjectOneParty))"
                          :no-match-text='$t("msg_generics.no_match")',
                          v-model='filterForm.thirdValueSelect',
                          filterable,
                          multiple,
                          collapse-tags,
                          :placeholder='$t(selectedCentre.placeholder)')
                          ods-option(
                            v-for='option in selectedCentre.options',
                            :key='option.id',
                            :label='option.code',
                            :value='option.id')
                        ods-tooltip(
                          v-if="(this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'sellerId')"
                          placement="top")
                          template(slot='content')
                            | {{ centreUser.code }}
                          ods-input.others-input(
                            v-model='centreUser.code',
                            :disabled='true')
                    //- Centro comprador
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show="(selected.prop === 'buyerId' && filterForm.secondValueSelect && this.canViewDistributionCentres)")
                        ods-form-item.others-input(prop='thirdValueSelectBuyer')
                          ods-select(
                              v-if="(selected.prop === 'buyerId' && (selectedBuyer || this.userLoggedOneProjectOneParty))"
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.thirdValueSelectBuyer',
                            filterable,
                            multiple,
                            collapse-tags,
                            :placeholder='$t(selectedCentreBuyer.placeholder)')
                            ods-option(
                              v-for='option in selectedCentreBuyer.options',
                              :key='option.id',
                              :label='option.code',
                              :value='option.id')

                    //- Lugar de entrega
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show="(selected.prop === 'buyerId' && filterForm.secondValueSelect && this.canViewDistributionCentres)")
                        ods-form-item.others-input(prop='thirdValueSelectDelivery')
                          ods-select(
                              v-if="(selected.prop === 'buyerId' && (selectedBuyer || this.userLoggedOneProjectOneParty))"
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.thirdValueSelectDelivery',
                            filterable,
                            multiple,
                            collapse-tags,
                            :placeholder='$t(selectedCentreDelivery.placeholder)')
                            ods-option(
                              v-for='option in selectedCentreDelivery.options',
                              :key='option.id',
                              :label='option.code',
                              :value='option.id')

                    //- Centro facturado
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show="(selected.prop === 'buyerId' && filterForm.secondValueSelect  && this.canViewDistributionCentres)")
                        ods-form-item.others-input(prop='thirdValueSelectInvoicee')
                          ods-select(
                              v-if="(selected.prop === 'buyerId' && (selectedBuyer || this.userLoggedOneProjectOneParty))"
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.thirdValueSelectInvoicee',
                            filterable,
                            multiple,
                            collapse-tags,
                            :placeholder='$t(selectedCentreInvoicee.placeholder)')
                            ods-option(
                              v-for='option in selectedCentreInvoicee.options',
                              :key='option.id',
                              :label='option.code',
                              :value='option.id')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        ods-button(
                          :disabled="!activeButtonAddFilter",
                          icon='ods-icon-plus',
                          size='medium',
                          circle,
                          @click.native="onSubmit('filterForm')")

        .b2b-filters__container(v-if='listSelectedFiltersEmittedPayrolls.length > 0')
          transition-group.b2b-filters__group(
            name='ods-fade-in-linear',
            tag='div')
            ods-popover(
              key='icon-delete-filters',
              placement='top-start',
              trigger='hover',
              :content='$t("msg_generics.popover_clean_filters")')
              ods-button.clean-filters(
                slot='reference',
                type='neutral',
                size='small',
                icon='ods-icon-delete',
                @click='handleDeleteAllFilters')

            .b2b-filters__button(
              v-for='(filter, index) in listSelectedFiltersEmittedPayrolls',
              :key='index')
              b2b-filter-button-facturas-emitidas(
                :filter='filter',
                @closeTag='resetSelectedOneOption')
        ods-dialog(
          ref='dialogAddInvoice',
          :title='$t("invoices.dialog_add_invoice.title")',
          :visible.sync='isShowDialogAddInvoice',
          :append-to-body='true',
          @close='handleCloseDialog',
          width='40%')
          ods-form(
            ref='formDialogAddInvoice',
            :rules='rulesDialogAddInvoice',
            :model='formDialogAddInvoice',
            size='mini')
            ods-form-item(
              v-show='!(activeUser.data && activeUser.data.projects && activeUser.data.projects.length === 1)',
              :label='$t("invoices.dialog_add_invoice.project.label")',
              prop='servicio'
              )
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddInvoice.servicio',
                filterable,
                clearable,
                :placeholder='$t("invoices.dialog_add_invoice.project.placeholder")',
                @change='getProject')
                ods-option(
                  v-for='option in optionsFilterService',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
            ods-form-item(
              :label='$t("invoices.dialog_add_invoice.format.label")'
              prop='formato')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddInvoice.formato',
                filterable,
                :placeholder='$t("invoices.dialog_add_invoice.format.placeholder")')
                ods-option(
                  v-for='option in formatos',
                  :key='option.value',
                  :label='option.value',
                  :value='option.value')
            ods-form-item(prop='fichero', ref='form-item-upload')
              ods-upload(
              v-model='formDialogAddInvoice.fichero',
              ref='upload',
              action='#',
              :auto-upload='false',
              :on-change='onSuccessUpload',
              :on-remove='handleRemoveUpload',
              :file-list='fileList')
                ods-button(
                  icon='ods-icon-plus',
                  size='small',
                  circle)
                  | {{ $t('invoices.dialog_add_invoice.button_select_invoice') }}
            ods-form-item.labelAttachments(
              v-if='canSeeAttachments',
              name='1')
              template(slot='label')
                span.info {{ $t('invoice_detail.attachment') }}
            ods-form(
              ref='formAddInvoiceAttachment',
              :rules='rulesAddInvoiceAttachment',
              :model='formAddInvoiceAttachment')
              ods-form-item.upload-attachment(prop='fichero', ref='form-item-upload-attachment')
                ods-upload(
                  v-model='formAddInvoiceAttachment.fichero',
                  ref='upload',
                  action='#',
                  :auto-upload='false',
                  :on-change='onSuccessUploadAttachment',
                  :file-list='fileListAttachments',
                  :accept= 'extensionFormatsAccept.toString()')
                  ods-button(
                    icon='ods-icon-plus',
                    size='small',
                    circle)
                    | {{ $t('invoices.dialog_add_invoice.attachments.label') }}
              //- Tabla de Adjuntos
              ods-table(
                v-if='formDialogAddInvoice.attachments.length > 0'
                :data='formDialogAddInvoice.attachments',
                :default-sort='{ prop: "creationDate", order: "descending" }',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                empty-text=' '
                fit)
                ods-table-column(
                  label='Nombre fichero'
                  prop='name')
                ods-table-column(
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      type='neutral',
                      @click.native.prevent='removeAttachment(scope.$index, formDialogAddInvoice.attachments)')
                      ods-icon(name='close', size='14')
            ods-form-item.margin(
              v-if='isShowMethod',
              :label='$t("invoices.dialog_add_invoice.communication_method.label")',
              prop='metodoEntrega')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddInvoice.metodoEntrega',
                filterable,
                clearable,
                :placeholder='$t("invoices.dialog_add_invoice.communication_method.placeholder")')
                ods-option(
                  v-for='option in optionsCommunicationMethods',
                  :key='option.id',
                  :label='$t("communication_method." + option.name)',
                  :value='option.id')
          span(slot='footer')
            ods-button(
              type='primary',
              @click.native='onSubmitAddInvoice("formDialogAddInvoice")')
              | {{ $t('invoices.dialog_add_invoice.button_upload') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonFacturasEmitidas from '@/views/facturas/emitidas/B2bFilterButtonFacturasEmitidas'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-facturas-emitidas',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonFacturasEmitidas
  },

  data () {
    const _this = this
    const checkNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumber(value)) {
        callback(new Error(this.$t('msg_generics.format_invalid')))
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    const checkNegativeNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumber(value, true)) {
        callback(new Error(this.$t('msg_generics.format_invalid')))
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    const validateRate = (rule, value, callback) => {
      if (value > 1000) {
        callback(new Error(this.$t('msg_generics.max_value', { max: 1000 })))
      } else {
        callback()
      }
    }

    return {
      activeButtonAddFilter: true,
      userLoggedOneProjectOneParty: false, // Flag que nos indica si el usuario tiene 1 solo proyecto y una sola empresa
      userLoggedOneProjectOnePartyOneCentre: false, // Flag que nos indica si el usuario tiene 1  proyecto 1 empresa 1 centro
      partyNameUser: '',
      selectedBuyer: false, // Flag que indica cuando tienen que mostrarse los centros compradores
      selectedSeller: false, // Flag que indica cuando tienen que mostrarse los centros vendedores
      // DatePicker
      dateTimePickerValue: [],
      filterDatePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },

      tid: null,

      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueNumber: '',
        secondValueDecimal: '',
        secondValueSelect: [],
        thirdValueSelect: [],
        thirdValueSelectBuyer: [],
        thirdValueSelectDelivery: [],
        thirdValueSelectInvoicee: [],
        invoiceNumber: '',
        registerNumber: '',
        invoiceSeriesCode: '',
        id: '',
        rate: '',
        secondValueSelectMultiple: []
      },
      selected: {},
      selectedCentre: {},
      selectedCentreBuyer: {},
      selectedCentreDelivery: {},
      selectedCentreInvoicee: {},
      selectedFilters: [],
      options: {},
      auxListPartiesBuyer: [],
      auxListPartiesSeller: [],
      centreUser: {},
      optionsInvoiceSent: [{
        value: this.$t('invoice_sent_flag.SENT'),
        code: 'SENT'
      },
      {
        value: this.$t('invoice_sent_flag.PENDING_OF_SEND'),
        code: 'PENDING_OF_SEND'
      },
      {
        value: this.$t('invoice_sent_flag.NOT_SENT'),
        code: 'NOT_SENT'
      }],

      // Reglas Validación
      rules: {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 1500, message: this.$t('msg_generics.max_num_character', { max: 1500 }), trigger: 'change' }
        ],
        registerNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 60, message: this.$t('msg_generics.max_num_character', { max: 60 }), trigger: 'change' }
        ],
        invoiceSeriesCode: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 20, message: this.$t('msg_generics.max_num_character', { max: 20 }), trigger: 'change' }
        ],
        id: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 10, message: this.$t('msg_generics.max_num_character', { max: 10 }), trigger: 'change' },
          { pattern: /^[0-9]*$/, message: this.$t('msg_generics.number_required'), trigger: 'change' }
        ],
        rate: [
          { pattern: /^[0-9]*$/, message: this.$t('msg_generics.number_required'), trigger: 'change' },
          { validator: validateRate, trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { validator: checkNumber, trigger: 'change' }
        ],
        secondValueDecimal: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { validator: checkNegativeNumber, trigger: 'change' }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ],
        secondValueSelectMultiple: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'click'
          }
        ],
        thirdValueSelect: [
          {
            required: this.firstValue === this.$t('invoices.filters.buyer.value') || this.firstValue === this.$t('invoices.filters.seller.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ],
        thirdValueSelectBuyer: [
          {
            required: this.firstValue === this.$t('invoices.filters.buyer.value') || this.firstValue === this.$t('invoices.filters.seller.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ],
        thirdValueSelectDelivery: [
          {
            required: this.firstValue === this.$t('invoices.filters.buyer.value') || this.firstValue === this.$t('invoices.filters.seller.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ],
        thirdValueSelectInvoicee: [
          {
            required: this.firstValue === this.$t('invoices.filters.buyer.value') || this.firstValue === this.$t('invoices.filters.seller.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      },
      servicios: [],
      formatos: [
        {
          value: 'FACTURAE32'
        },
        {
          value: 'FACTURAE321'
        },
        {
          value: 'FACTURAE322'
        },
        {
          value: 'FATTURAPA12'
        },
        {
          value: 'FEV1'
        },
        {
          value: 'INVOIC_D01B'
        },
        {
          value: 'INVOIC_D93A'
        },
        {
          value: 'INVOIC_D96A'
        },
        {
          value: 'INVOIC_D97A'
        },
        {
          value: 'UBL21'
        },
        {
          value: 'XCBL40'
        }
      ],

      noErrorStatusOptions: [
        {
          code: this.$t('invoices.filters.no_error_status.rejected'),
          value: 'rejectedStatus'
        },
        {
          code: this.$t('invoices.filters.no_error_status.final'),
          value: 'finalStatus'
        }
      ],
      // Carga factura
      fileList: [],
      isShowDialogAddInvoice: false,
      isShowMethod: false,
      formDialogAddInvoice: {
        servicio: null,
        formato: null,
        fichero: null,
        metodoEntrega: null,
        attachments: []
      },
      ultimaPulsacionFiltroEmpresa: 0,
      fileListAttachments: [],
      formAddInvoiceAttachment: {
        fichero: null
      },
      rulesDialogAddInvoice: {
        servicio: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }
        ],
        formato: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }
        ],
        fichero: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.attachments_table.fileselected'
            ),
            trigger: 'click'
          }
        ]
      },
      optionsCommunicationMethods: [],
      extensionFormatsAccept: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],
      extensionFormats: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg']

    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryEmittedPayrolls',
      'listSelectedFiltersEmittedPayrolls',
      'optionsFilterInvoiceEmitBuyer',
      'optionsFilterInvoiceEmitSeller',
      'optionsFilterService',
      'optionsFilterInvoiceStatus',
      'optionsFilterInvoiceClasses',
      'optionsFilterInvoiceSendMethods',
      'optionsFilterInvoiceTaxType',
      'optionsFilterCurrency',
      'optionsFilterChannel',
      'optionsFilterInvoiceType',
      'optionsFilterPaymentMethod',
      // Permisos
      'canUploadInvoice',
      'canSearchChannel',
      'canSeeAttachments',
      'canAddAttachments',
      'canAttachmentHidden',
      'canCancelInvoice',
      'canViewDistributionCentres',
      'urlIn'
    ]),

    rulesAddInvoiceAttachment () {
      const checkExtension = (rule, value, callback) => {
        // Obtener la extension, y cuando la tengas, haces la validacion
        if (!this.validateExtension(this.formAddInvoiceAttachment.fichero.name)) {
          callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '.' + this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension_values') + this.extensionFormats.toString()))
        } else {
          this.fileListAttachments.push(this.formAddInvoiceAttachment.fichero)
          this.onSubmitAddAttachment()
          callback()
        }
      }
      return {
        fichero: [
          { required: true, message: this.$t('pendingtask.pendingtask_detail.attachments_table.fileselected'), trigger: 'click' },
          { validator: checkExtension }
        ]
      }
    }
  },

  watch: {
    $route (to) {
      this.listSelectedFiltersEmittedPayrolls = this.listSelectedFiltersEmittedPayrolls // eslint-disable-line
    }
  },

  methods: {
    activeRefreshInvoices () {
      this.refreshResults()
    },
    ...mapActions([
      'getPayrolls',
      'queryEmittedPayrollsState',
      'listSelectedFiltersEmittedPayrollsState',
      'handleUploadInvoiceNote',
      'getOptionsFilterPartyMEFenixBackend',
      'optionsFilterInvoiceEmitBuyerState',
      'optionsFilterInvoiceEmitSellerState',
      'getCommunicationsMethodsUpload',
      'getOptionsFilterChannel',
      'getOptionsFilterCentresOrderByEnabledFenixBackend',
      'getCentresByPartyFenixBackend',
      'getOptionsService',
      'optionsFilterServiceState',
      'getOptionsFilterInvoiceSendMethods',
      'getUserSponsor'
    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      switch (type) {
        case 'taxTypeCode':
          key = 'tax_type.'
          break
        case 'communicationMethodId':
          key = 'communication_method.'
          break
        case 'statusId':
          key = 'invoice_status.'
          break
        case 'invoiceTypeId':
          key = 'invoice_type.'
          break
      }
      return this.$t(key + code)
    },

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },
    async getProject (data) {
      if (!data) {
        if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
          this.optionsCommunicationMethods = await this.getCommunicationsMethodsUpload({
            serviceId: this.activeUser.data.projects[0].id,
            sender: 'SENDER'
          })

          this.isShowMethod = await this.getUserSponsor(this.activeUser.data.projects[0].id)
          console.log('isUserSponsor: ', this.isShowMethod)
        } else {
          this.optionsCommunicationMethods = []
          this.formDialogAddInvoice.metodoEntrega = null
        }
      } else {
        this.isShowMethod = await this.getUserSponsor(data)
        console.log('isUserSponsor: ', this.isShowMethod)

        const load = this.$loading({
          lock: true,
          text: 'Cargando datos'
        })
        try {
          this.optionsCommunicationMethods = await this.getCommunicationsMethodsUpload({
            serviceId: data,
            sender: 'SENDER'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },
    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddInvoice.fichero = file
      this.$refs.formDialogAddInvoice.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    onSuccessUploadAttachment (file, fileList) {
      this.formAddInvoiceAttachment.fichero = file
      this.$refs.formAddInvoiceAttachment.validateField('fichero')
    },

    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    handleRemoveUploadAttachment (file, fileList) {
      this.$refs['form-item-upload-attachment'].resetField('fichero')
      this.fileListAttachments = []
    },

    removeAttachment (index, rows) {
      rows.splice(index, 1)
    },

    onSubmitAddAttachment () {
      this.formDialogAddInvoice.attachments.push(this.formAddInvoiceAttachment.fichero)
      this.handleRemoveUploadAttachment()
    },

    // Reseteo al cerrar dialogo
    async handleCloseDialog () {
      this.$refs.formDialogAddInvoice.resetFields()
      this.handleRemoveUpload()
      this.handleRemoveUploadAttachment()
      this.formDialogAddInvoice.attachments = []
      this.formDialogAddInvoice.fichero = null
      this.formAddInvoiceAttachment.fichero = null

      const dataQuery = { page: 0, size: 1000, sort: 'name,ASC', isSender: true, urlName: (this.urlIn && this.urlIn !== 'b2b' ? this.urlIn : null) }
      const optionsFilterService = await this.getOptionsService(dataQuery)
      await this.optionsFilterServiceState(optionsFilterService)
    },

    onSubmitAddInvoice (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitAddInvoice!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_invoice')
          })
          try {
            await this.handleUploadInvoiceNote({
              invoice: this.fileList[0],
              projectId: this.formDialogAddInvoice.servicio,
              format: this.formDialogAddInvoice.formato,
              communicationMethodId: this.formDialogAddInvoice.metodoEntrega,
              attachments: this.formDialogAddInvoice.attachments
            })
            if (this.urlIn && this.urlIn !== 'b2b') {
              this.queryEmittedPayrolls.urlName = this.urlIn
            } else {
              this.queryEmittedPayrolls.urlName = null
            }
            const dataQuery = {
              query: this.queryEmittedPayrolls
            }
            await this.getPayrolls(dataQuery)

            // Reiniciamos formulario, cerramos dialog y mostramos notificacion
            this.$refs[formName].resetFields()
            this.isShowDialogAddInvoice = false
            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('onSubmitAddInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            console.log('Despues del showNot')
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    async getFirstValue (data) {
      this.filterForm.invoiceNumber = ''
      this.filterForm.registerNumber = ''
      this.filterForm.invoiceSeriesCode = ''
      this.filterForm.rate = ''
      this.filterForm.id = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueNumber = ''
      this.filterForm.secondValueDecimal = ''
      this.filterForm.secondValueSelect = ''
      this.filterForm.secondValueSelectMultiple = []
      this.filterForm.thirdValueSelect = []
      this.filterForm.thirdValueSelectBuyer = []
      this.filterForm.thirdValueSelectDelivery = []
      this.filterForm.thirdValueSelectInvoicee = []
      this.$refs.filterForm.clearValidate()
      this.selected = data

      await this.getPreloadParties(data.prop, this.queryEmittedPayrolls.projectId)

      // Precarga de centro y empresa en el combo de vendedores, si procede
      // Se pueden dar 3 casuísticas distintas
      // 1.Usuario con 1 proyecto y 1 empresa y centros === null
      // 2.Usuario con 1 proyecto 1 empresa y 1 centro
      // 3.El resto de casos

      // No tiene 1 solo proyecto y 1 sola empresa.
      if (!this.userLoggedOneProjectOneParty) {
        this.activeButtonAddFilter = true
      } else {
        // 1 proyecto - 1 empresa y 1 a N centros
        if (data.prop === 'sellerId') {
          this.filterForm.secondValueSelect = this.optionsFilterInvoiceEmitSeller[0].tradeName
          this.selected.query = this.optionsFilterInvoiceEmitSeller[0].id
          this.selected.labelText = this.optionsFilterInvoiceEmitSeller[0].tradeName
          this.selected.partyId = this.selected.labelText

          // 2.Usuario con 1 proyecto 1 empresa y un centro
          if (this.userLoggedOneProjectOnePartyOneCentre) {
            const load = this.$loading({
              lock: true
            })
            const data = {
              projectId: this.activeUser.data.projects ? this.activeUser.data.projects[0].id : null,
              partyId: this.activeUser.data.projects ? this.activeUser.data.projects[0].parties[0].id : null
            }
            try {
              const centroBd = await this.getCentresByPartyFenixBackend(data)
              this.centreUser = {
                id: centroBd[0].id,
                code: centroBd[0].code,
                roles: centroBd[0].centreRoles
              }
              this.selected.labelText = centroBd[0].code
              this.filterForm.thirdValueSelect = this.centreUser.id
            } catch (error) {
              console.log('getCentresByParty CATCH: ', error)
              this.getNotificationErrorMessage(error)
            } finally {
              load.close()
            }
            this.activeButtonAddFilter = false

          // 1.Usuario con 1 proyecto y 1 empresa y centros === null
          } else if (this.userLoggedOneProjectOneParty) {
            const party = {
              query: this.optionsFilterInvoiceEmitSeller[0].id,
              prop: 'sellerId'
            }
            await this.getListCentres(party)
            this.selectedCentre = this.selected.centro_vendedor
            this.activeButtonAddFilter = true
          }
        } else {
          this.activeButtonAddFilter = true
        }
      }
    },
    getSecondValue (data) {
      if (
        this.selected.componente === 'select' &&
        (this.selected.prop === 'idProject' ||
        this.selected.prop === 'channelId')
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.name
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'sent'
      ) {
        const option = this.optionsInvoiceSent.find(function (elem) {
          return elem.code === data
        })
        this.selected.query = data
        this.selected.labelText = option.value
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'noErrorStatus'
      ) {
        const option = this.noErrorStatusOptions.find(function (elem) {
          return elem.value === data
        })
        this.selected.query = data
        this.selected.labelText = option.code
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'documentClassCode'
      ) {
        this.selected.query = data
        this.selected.labelText = this.$t('document_class.' + data)
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'currencyId'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.$t('currency.' + option.code)
      } else if (
        this.selected.prop === 'withAttachment' ||
        this.selected.prop === 'cancellationRequest' ||
        this.selected.prop === 'sent'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.value
        this.selected.labelText = this.$t('msg_generics.question.' + option.type)
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'paymentMethod'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = data
        this.selected.labelText = this.$t('paymentmethod.' + option.name)
      } else if (
        this.selected.prop === 'taxTypeCode' ||
        this.selected.prop === 'communicationMethodId' ||
        this.selected.prop === 'invoiceTypeId'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.formatterLabel(option.code)
      } else if (this.selected.prop === 'statusId') {
        const self = this
        let description = ''
        const estados = this.selected.options

        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          estados.find(function (elem) { // eslint-disable-line
            if (elem.id === element) {
              description += self.$t('invoice_status.' + elem.code)
              if (index < data.length - 1) {
                description += ','
              }
            }
          })
        }
        this.selected.labelText = description
      } else if (
        (this.selected.componente === 'select' &&
          this.selected.prop === 'buyerId') ||
        this.selected.prop === 'sellerId'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.tradeName
        this.selected.partyId = this.selected.labelText
        // Obtenemos la lista de centros asociados al componente seleccionado, ya sea comprador o vendedor

        this.getListCentres(this.selected)
        if (this.selected.prop === 'buyerId') {
          this.selectedCentre = this.selected.centro
          this.selectedCentreBuyer = this.selected.centro_comprador
          this.selectedCentreDelivery = this.selected.centro_entrega
          this.selectedCentreInvoicee = this.selected.centro_facturado
          this.selectedBuyer = true
        } else {
          this.selectedCentre = this.selected.centro_vendedor
          this.selectedSeller = true
        }
        if (this.selectedCentre) {
          this.activeButtonAddFilter = true
        } else {
          this.activeButtonAddFilter = false
        }
      } else if (this.selected.componente === 'date') {
        this.selected.labelText = data.query
      } else {
        this.selected.query = data.id
        this.selected.labelText = data.code
        this.filterForm.secondValueSelect = data.code
      }

      if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }
      this.$refs.filterForm.clearValidate()
    },

    // Precargamos los combos de vendedor y comprador cuando el resultado sea menor de 50,
    // El de vendedor para el caso en que no sea un usuario unica empresa (ya que para este caso se precargará con la unica empresa) y si es superadministrador se debe haber seleccionado el proyecto
    // El comprador para el caso que no sea superadministrador o se haya seleccionado el proyecto
    async getPreloadParties (propSelected, projectId) {
      if (propSelected === 'sellerId') {
        if (((this.activeUser.data.isSuperAdmin && projectId) || (!this.activeUser.data.isSuperAdmin && !this.userLoggedOneProjectOneParty))) {
          this.optionsFilterInvoiceEmitSellerState([])
          const dataQuerySeller = {
            role: 'SELLER',
            emission: true,
            seller: true,
            page: 0,
            size: 55,
            projectId: projectId,
            enable: true
          }
          const vendedores = await this.getOptionsFilterPartyMEFenixBackend(dataQuerySeller)
          if (vendedores.length < 51) {
            this.optionsFilterInvoiceEmitSellerState(vendedores)
            this.selected.options = vendedores
            if (vendedores.length === 1) {
              this.queryEmittedPayrolls.sellerId = vendedores[0].id
            }
          } else {
            this.optionsFilterInvoiceEmitSellerState([])
          }
        } else {
          if (!this.userLoggedOneProjectOneParty) {
            this.optionsFilterInvoiceEmitSellerState([])
          }
        }
      }

      if (propSelected === 'buyerId') {
        if (((this.activeUser.data.isSuperAdmin && projectId) || (!this.activeUser.data.isSuperAdmin))) {
          this.optionsFilterInvoiceEmitBuyerState([])
          const dataQueryBuyer = {
            role: 'BUYER',
            emission: true,
            seller: false,
            page: 0,
            size: 55,
            projectId: projectId,
            enable: true
          }
          const compradores = await this.getOptionsFilterPartyMEFenixBackend(dataQueryBuyer)
          if (compradores.length < 51) {
            this.optionsFilterInvoiceEmitBuyerState(compradores)
            this.selected.options = compradores
            if (compradores.length === 1) {
              this.queryEmittedPayrolls.buyerId = compradores[0].id
            }
          } else {
            this.optionsFilterInvoiceEmitBuyerState([])
          }
        } else {
          this.optionsFilterInvoiceEmitBuyerState([])
        }
      }
    },

    getDescriptionCentreSelectLabel (data, labelCentres, centros) {
      let description = ''
      if (data && data.length > 0) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          centros.find(function (centro) { // eslint-disable-line
            if (centro.id === element) {
              const aux = centro.code.split('-', 1)
              description += aux
              if (index < data.length - 1) {
                description += ','
              }
            }
          })
        }
      }
      if (description.length > 35) {
        let shorterTag = description.slice(0, 35)
        shorterTag = shorterTag.slice(0, shorterTag.lastIndexOf(','))
        description = shorterTag + '...'
      }
      return description.length > 0 ? labelCentres + ': ' + description : ''
    },

    getBuyerAndCentreFilterLabel () {
      const partySelected = this.selected.partyId
      this.selected.labelText = partySelected + ' ' + this.getDescriptionCentreSelectLabel(this.filterForm.thirdValueSelect, this.$t('breadcrumb.administration_project_admin_centresOfBuyer'), this.selected.centro.options) + ' ' + this.getDescriptionCentreSelectLabel(this.filterForm.thirdValueSelectBuyer, this.$t('breadcrumb.administration_project_admin_centresbuyer'), this.selected.centro_comprador.options) + ' ' + this.getDescriptionCentreSelectLabel(this.filterForm.thirdValueSelectDelivery, this.$t('breadcrumb.administration_project_admin_centresdelivery'), this.selected.centro_entrega.options) + ' ' + this.getDescriptionCentreSelectLabel(this.filterForm.thirdValueSelectInvoicee, this.$t('breadcrumb.administration_project_admin_centresinvoicee'), this.selected.centro_facturado.options)
    },
    getSellerAndCentreFilterLabel () {
      const partySelected = this.selected.partyId
      this.selected.labelText = partySelected + ' ' + this.getDescriptionCentreSelectLabel(this.filterForm.thirdValueSelect, this.$t('breadcrumb.administration_project_admin_centresOfSeller'), this.selected.centro_vendedor.options)
    },
    // Metodo auxiliar para obtener la lista de centros asociados a unna empresa,ya sea compradora o vendedora
    async getListCentres (party) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const dataQuery = {
        idProject: this.queryEmittedPayrolls.projectId,
        idParty: party.query,
        isBuyer: null,
        isSeller: null,
        isEnable: null,
        roles: null
      }
      try {
        if (party.prop === 'buyerId') {
          dataQuery.isBuyer = true
          this.options.comprador.centro.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
          if (this.canViewDistributionCentres) {
            this.options.comprador.centro_comprador.options = []
            this.options.comprador.centro_entrega.options = []
            this.options.comprador.centro_facturado.options = []
            dataQuery.roles = 'buyer, ship_to, invoicee'
            const centresOfBuyer = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
            for (let index = 0; index < centresOfBuyer.length; index++) {
              const element = centresOfBuyer[index]
              if (element.centreRoles.includes('buyer')) {
                this.options.comprador.centro_comprador.options.push(element)
              }
              if (element.centreRoles.includes('ship_to')) {
                this.options.comprador.centro_entrega.options.push(element)
              }
              if (element.centreRoles.includes('invoicee')) {
                this.options.comprador.centro_facturado.options.push(element)
              }
            }
          }
        } else {
          dataQuery.isSeller = true
          this.options.vendedor.centro_vendedor.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
        }
      } catch (error) {
        console.log('getListCentres CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    onSubmit (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            console.log('column ', column)
            switch (column) {
              case 'invoiceTypeId':
                this.queryEmittedPayrolls.invoiceTypeId = this.selected.query
                break
              case 'buyerId':
                this.queryEmittedPayrolls.buyerId = this.selected.query
                this.queryEmittedPayrolls.buyerGenericCentreId = this.filterForm.thirdValueSelect
                if (this.canViewDistributionCentres) {
                  this.queryEmittedPayrolls.buyerCentreId = this.filterForm.thirdValueSelectBuyer
                  this.queryEmittedPayrolls.deliveryCentreId = this.filterForm.thirdValueSelectDelivery
                  this.queryEmittedPayrolls.invoiceeCentreId = this.filterForm.thirdValueSelectInvoicee
                }
                this.getBuyerAndCentreFilterLabel()
                break
              case 'sellerId':
                this.queryEmittedPayrolls.sellerId = this.selected.query
                this.queryEmittedPayrolls.sellerCentreId = this.filterForm.thirdValueSelect
                this.getSellerAndCentreFilterLabel()
                break
              case 'invoiceNumber':
                this.queryEmittedPayrolls.invoiceNumber = this.selected.query.trim()
                break
              case 'idProject':
                this.queryEmittedPayrolls.projectId = this.selected.query
                break
              case 'statusId':
                this.queryEmittedPayrolls.statusId = this.filterForm.secondValueSelectMultiple
                break
              case 'documentClassCode':
                this.queryEmittedPayrolls.documentClassCode = this.selected.query
                break
              case 'communicationMethodId':
                this.queryEmittedPayrolls.communicationMethodId = this.selected.query
                break
              case 'taxTypeCode':
                this.queryEmittedPayrolls.taxTypeCode = this.selected.query
                break
              case 'currencyId':
                this.queryEmittedPayrolls.currencyId = this.selected.query
                break
              case 'orderNumber':
                this.queryEmittedPayrolls.orderNumber = this.selected.query.trim()
                break
              case 'contract':
                this.queryEmittedPayrolls.contract = this.selected.query.trim()
                break
              case 'deliveryNote':
                this.queryEmittedPayrolls.deliveryNote = this.selected.query.trim()
                break
              case 'file':
                this.queryEmittedPayrolls.file = this.selected.query
                break
              case 'invoiceSeriesCode':
                this.queryEmittedPayrolls.invoiceSeriesCode = this.selected.query.trim()
                break
              case 'correctiveInvoiceNumber':
                this.queryEmittedPayrolls.correctiveInvoiceNumber = this.selected.query.trim()
                break
              case 'issueDates':
                this.queryEmittedPayrolls.issueDateFrom = this.selected.query[0]
                this.queryEmittedPayrolls.issueDateTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              case 'operationDates':
                this.queryEmittedPayrolls.operationDateFrom = this.selected.query[0]
                this.queryEmittedPayrolls.operationDateTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              case 'channelId':
                this.queryEmittedPayrolls.channelId = this.selected.query
                break
              case 'registerNumber':
                this.queryEmittedPayrolls.registerNumber = this.selected.query.trim()
                break
              case 'id':
                this.queryEmittedPayrolls.id = this.selected.query.trim()
                break
              case 'noErrorStatus':
                this.queryEmittedPayrolls.noErrorStatus = this.selected.query
                break
              case 'totalExecutableAmountFrom':
                this.selected.query = this.selected.query.replace(',', '.')
                this.queryEmittedPayrolls.totalExecutableAmountFrom = this.selected.query
                break
              case 'totalExecutableAmountTo':
                this.selected.query = this.selected.query.replace(',', '.')
                this.queryEmittedPayrolls.totalExecutableAmountTo = this.selected.query
                break
              case 'withAttachment':
                this.queryEmittedPayrolls.withAttachment = this.selected.query
                break
              case 'sent':
                this.queryEmittedPayrolls.sent = this.selected.query
                break
              case 'rate':
                this.queryEmittedPayrolls.rate = this.selected.query
                break
              case 'cancellationRequest':
                this.queryEmittedPayrolls.cancellationRequest = this.selected.query
                break
              case 'paymentMethod':
                this.queryEmittedPayrolls.paymentMethod = this.selected.query
                break
              case 'accountingDate':
                this.queryEmittedPayrolls.accountingDateFrom = this.selected.query[0]
                this.queryEmittedPayrolls.accountingDateTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              case 'paymentDate':
                this.queryEmittedPayrolls.paymentDateFrom = this.selected.query[0]
                this.queryEmittedPayrolls.paymentDateTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersEmittedPayrolls
            console.log('FILTROS SELECCIONADOS: ', this.selectedFilters)

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersEmittedPayrollsState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()
            this.filterForm.filterDatePickerValue = []
            this.queryEmittedPayrolls.page = 0
            await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
            console.log('queryEmittedPayrolls: ', this.queryEmittedPayrolls)

            dataQuery.query = this.queryEmittedPayrolls
            const response = await this.getPayrolls(dataQuery)
            this.totalResults = response.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        }
      })
    },

    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })

      try {
        await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
        dataQuery.query = this.queryEmittedPayrolls
        const response = await this.getPayrolls(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('refreshResults CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getDateTimePickerValue () {
      if (!this.dateTimePickerValue) {
        this.dateTimePickerValue = []
        this.dateTimePickerValue.push(this.queryEmittedPayrolls.creationDateTimeFrom)
        this.dateTimePickerValue.push(this.queryEmittedPayrolls.creationDateTimeTo)
      } else {
        this.queryEmittedPayrolls.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryEmittedPayrolls.creationDateTimeTo = this.dateTimePickerValue[1]
        const dataQuery = {
          query: {}
        }
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.filter_date')
        })

        try {
          await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
          dataQuery.query = this.queryEmittedPayrolls
          await this.getPayrolls(dataQuery)
        } catch (error) {
          console.log('getDateTimePickerValue CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Filtro Fechas Incidencias
    getDateRangePickerValue () {
      console.log('getDatePickerValue: ', this.filterDatePickerValue)
      this.selected.query = this.filterDatePickerValue
      this.getSecondValue(this.selected)
    },

    async activateUpload () {
      const dataQueryService = { page: 0, size: 1000, enabled: true, sort: 'name,ASC' }
      const result = await this.getOptionsService(dataQueryService)
      await this.optionsFilterServiceState(result)
      this.isShowDialogAddInvoice = true
    },
    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
        await this.listSelectedFiltersEmittedPayrollsState([])
        this.selectedFilters = this.listSelectedFiltersEmittedPayrolls.map(
          item => {
            item.labelText = ''
            item.query = ''
            item.selected = false
            return item
          }
        )
        await this.listSelectedFiltersEmittedPayrollsState(
          this.selectedFilters
        )

        if (!this.dateTimePickerValue) {
          this.queryEmittedPayrolls.creationDateTimeFrom = ''
          this.queryEmittedPayrolls.creationDateTimeTo = ''
        } else {
          this.queryEmittedPayrolls.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryEmittedPayrolls.creationDateTimeTo = this.dateTimePickerValue[1]
        }

        this.queryEmittedPayrolls.searchType = 'EMITTED'
        this.queryEmittedPayrolls.buyerId = ''
        this.queryEmittedPayrolls.sellerId = ''
        this.queryEmittedPayrolls.issueDateFrom = ''
        this.queryEmittedPayrolls.issueDateTo = ''
        this.queryEmittedPayrolls.operationDateFrom = ''
        this.queryEmittedPayrolls.operationDateTo = ''
        this.queryEmittedPayrolls.invoiceNumber = ''
        this.queryEmittedPayrolls.projectId = ''
        this.queryEmittedPayrolls.statusId = ''
        this.queryEmittedPayrolls.documentClassCode = ''
        this.queryEmittedPayrolls.communicationMethodId = ''
        this.queryEmittedPayrolls.taxTypeCode = ''
        this.queryEmittedPayrolls.currencyId = ''
        this.queryEmittedPayrolls.orderNumber = ''
        this.queryEmittedPayrolls.contract = ''
        this.queryEmittedPayrolls.deliveryNote = ''
        this.queryEmittedPayrolls.file = ''
        this.queryEmittedPayrolls.invoiceSeriesCode = ''
        this.queryEmittedPayrolls.correctiveInvoiceNumber = ''
        this.queryEmittedPayrolls.buyerGenericCentreId = ''
        this.queryEmittedPayrolls.buyerCentreId = ''
        this.queryEmittedPayrolls.deliveryCentreId = ''
        this.queryEmittedPayrolls.invoiceeCentreId = ''
        this.queryEmittedPayrolls.sellerCentreId = ''
        this.queryEmittedPayrolls.registerNumber = ''
        this.queryEmittedPayrolls.id = ''
        this.queryEmittedPayrolls.noErrorStatus = ''
        this.queryEmittedPayrolls.invoiceTypeId = ''
        this.queryEmittedPayrolls.totalExecutableAmountFrom = ''
        this.queryEmittedPayrolls.totalExecutableAmountTo = ''
        this.queryEmittedPayrolls.withAttachment = ''
        this.queryEmittedPayrolls.sent = ''
        this.queryEmittedPayrolls.rate = ''
        this.queryEmittedPayrolls.cancellationRequest = ''
        this.queryEmittedPayrolls.paymentMethod = ''
        this.queryEmittedPayrolls.accountingDateFrom = ''
        this.queryEmittedPayrolls.accountingDateTo = ''
        this.queryEmittedPayrolls.paymentDateFrom = ''
        this.queryEmittedPayrolls.paymentDateTo = ''

        if (this.canSearchChannel) {
          this.queryEmittedPayrolls.channelId = ''
        }
        await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
        dataQuery.query = this.queryEmittedPayrolls
        await this.getPayrolls(dataQuery)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },

    async getBuyerResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const requestParty = {
        role: 'BUYER',
        seller: false,
        emission: true,
        projectId: this.queryEmittedPayrolls.projectId,
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
        this.selected.options = response
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async filterPartiesBuyer (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getBuyerResults, 1000, data)
        } else {
          this.auxListPartiesBuyer = []
          this.optionsFilterInvoiceEmitBuyerState(this.auxListPartiesBuyer)
        }
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getSellerResults (data) {
      try {
        const load = this.$loading({
          lock: true
        })
        const requestParty = {
          role: 'SELLER',
          seller: true,
          emission: true,
          projectId: this.queryEmittedPayrolls.projectId,
          page: 0,
          size: 1000,
          tradeNameOrTaxId: data
        }
        try {
          const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
          this.selected.options = response
          if (response && response.data && response.data.content) {
            this.auxListPartiesSeller = response.data.content
          } else {
            this.auxListPartiesSeller = []
          }
        } catch (error) {
          console.log('filterPartiesSeller CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async filterPartiesSeller (data) {
      // Si tiene 1 solo proyecto y 1 sola empresa no se permite el autocompletado
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getSellerResults, 1000, data)
          // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListPartiesSeller = []
          this.optionsFilterInvoiceEmitSellerState(this.auxListPartiesSeller)
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
        case 415:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 15000)
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersEmittedPayrollsState(data.listAfterRemove)
      this.initForm()
    },

    // Metodo que nos indica el numero de proyectos-empresas y centros de un usuario
    getProjectPartiesCentres () {
      let numParties = 0
      let numProject = 0
      let numCentres = 0
      if (this.activeUser.data && this.activeUser.data.projects) {
        numProject = this.activeUser.data.projects.length

        // Si el usuario logeado pertenece a un solo proyecto
        if (numProject === 1) {
          if (this.activeUser.data.projects[0].parties) {
            numParties = this.activeUser.data.projects[0].parties.length
          }
          // Si tiene una sola empresa
          if (numParties === 1 && this.activeUser.data.projects[0].parties[0].seller) {
            const vendedor = {
              id: this.activeUser.data.projects[0].parties[0].id,
              tradeName: this.activeUser.data.projects[0].parties[0].name
            }
            // seteamos la empresa en el campo vendedor
            const lstSeller = []
            lstSeller.push(vendedor)
            this.optionsFilterInvoiceEmitSellerState(lstSeller)
            // Activamos a true
            this.userLoggedOneProjectOneParty = true
            this.queryEmittedPayrolls.sellerId = vendedor.id

            // Si tiene un solo proyecto-centro y empresa
            if (this.activeUser.data.projects[0].parties[0].centres) {
              numCentres = this.activeUser.data.projects[0].parties[0].centres.length
              if (numCentres === 1) {
              // Activamos a true
                this.userLoggedOneProjectOnePartyOneCentre = true
              }
            }
          }
        }
      }
      // console.log('Numero de proyectos =' + numProject + ' Numero de empresas =' + numParties + 'Numero de centros =' + numCentres)
    },

    initForm () {
      if (!this.options.num_factura.selected) {
        this.filterForm.firstValue = this.options.num_factura
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    }
  },

  async created () {
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersEmittedPayrolls)

    // Si no tiene el permiso SEARCH_CHANNEL quitamos el filtro de canal
    if (this.activeUser && this.activeUser.data && this.activeUser.data.projects && this.activeUser.data.projects.length < 2) {
      delete this.options.servicio
    }

    if (!this.canSearchChannel) {
      delete this.options.canal
    }
    if (!this.canCancelInvoice) {
      delete this.options.solicitud_anulacion
    }

    this.initForm()
    this.getProjectPartiesCentres()
    if (this.queryEmittedPayrolls.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryEmittedPayrolls.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryEmittedPayrolls.creationDateTimeTo)
    }

    // Si solo tiene un proyecto asociado el usuario, cargamos ese proyecto en el combo
    // de cargar factura y en como filtro en general
    if (this.activeUser && this.activeUser.data && this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
      console.log('ACTIVE_USER', this.activeUser.data.projects[0].id)
      this.formDialogAddInvoice.servicio = this.activeUser.data.projects[0].id
      this.queryEmittedPayrolls.projectId = this.activeUser.data.projects[0].id
      await this.getProject()
    }
    try {
      await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
      await this.getOptionsFilterInvoiceSendMethods()
      if (this.canSearchChannel) {
        await this.getOptionsFilterChannel()
      }
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    this.options.comprador.options = this.optionsFilterInvoiceEmitBuyer
    this.options.vendedor.options = this.optionsFilterInvoiceEmitSeller
    if (this.optionsFilterService.length > 1 && this.options.servicio) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.estado.options = this.optionsFilterInvoiceStatus
    this.options.clase.options = this.optionsFilterInvoiceClasses
    this.options.envio.options = this.optionsFilterInvoiceSendMethods
    this.options.impuesto.options = this.optionsFilterInvoiceTaxType
    this.options.moneda.options = this.optionsFilterCurrency
    this.options.tipo_factura.options = this.optionsFilterInvoiceType
    this.options.paymentMethod.options = this.optionsFilterPaymentMethod
    if (this.canSearchChannel) {
      this.options.canal.options = this.optionsFilterChannel
    }
    console.log('updated filters options after load services data: ', this.options)
  }
}
</script>

<style lang="scss" scoped>
// BMG Tags centered into the status input into the container
::v-deep .ods-select__tags {
  margin-top: rem(20) !important;
  max-width: none !important;
}
::v-deep .b2b-filters__area .ods-form-item input {
  margin-bottom: rem(20) !important;
  height: 32px !important;
}
::v-deep .ods-select .ods-input.is-focus .ods-input__inner {
  height: 32px !important;
}
::v-deep .ods-input__prefix {
  height: 72px;
}
.b2b-filters {
  ::v-deep .ods-input__suffix {
    height: 72px;
  }
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader{
    font-size: 12px;
    padding: 0 28px 0 0px;
    color: var(--color-txt-secondary);
  }

  .ods-button {
    display: inline;
    margin-right: rem(24);  }

  .ods-form-item {
    .info {
      font-size: 18px;
      font-weight: 500;
      color: #060E14;
      text-transform: capitalize;
      margin-bottom:'0px';
    }
  }

  .ods-form-item.upload-attachment{
    margin-bottom: 12px;
  }

  .ods-form-item.labelAttachments{
    margin-bottom: 0px;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }
    .ods-form-item__label {
      display: none
    }
    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
  ::v-deep .ods-select .ods-tag {
    margin: 2px 0 -56px 6px;
  }
}
</style>
